import React from 'react'
import { styled } from '@mui/material/styles'

const colors = {
    primary: '#0057A0',
    grey: '#7d7c7c',
    black: '#000',
}

const StyledButton = styled('button')(({ active }) => ({
    fontFamily: 'Rubik',
    padding: '0 13px 8px 13px',
    fontSize: '1.6rem',
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    '& .icon-img': {
        display: 'inline-block',
    },
    '& span': {
        color: colors.black,
        position: 'relative',
        textTransform: 'initial',
        fontSize: '12px',
    },
    '& img': {
        position: 'relative',
    },
    ...(active && {
        borderBottom: `2px solid ${colors.primary}`,
        '& span': {
            color: colors.primary,
            fontSize: '12px',
        },
        '& .icon-img-light': {
            display: 'inline',
        },
    }),
}))

const TextIconButton = ({ text, icon, active, iconActive }) => (
    <StyledButton type="button" active={active}>
        <img
            className={'icon-img'}
            src={active ? iconActive : icon}
            alt=""
            aria-hidden="true"
        />
        <br />
        <span>{text}</span>
    </StyledButton>
)

export default TextIconButton
